'use client';

import { CSSProperties } from 'react';

import { Box, Container, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import 'swiper/css';
import 'swiper/css/pagination';
import { Mousewheel, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import Link from '@/components/Link';
import { collaborationProcess } from '@/config/collaboration-process.config';
import useBreakpoint from '@/utils/hooks/useBreakpoint';

import CollaborationProcessCard from './CollaborationProcessCard';
import styles from './CollaborationProcessSection.module.scss';

const CollaborationProcessSection = () => {
  const t = useTranslations('common.collaborationProcessSection');
  const { isBelowTablet } = useBreakpoint();

  return (
    <Container component="section" maxWidth="xl" className={styles.container}>
      <Stack gap={3} alignItems="center" className={styles.header}>
        <Typography variant="h2" component="h2" textAlign="center" className={styles.title}>
          {t('title')}
        </Typography>
        <Typography variant="body1" textAlign="center" className={styles.description}>
          {t('description')}
        </Typography>
        <Link href="/" text={t('linkText')} className={styles.link} />
      </Stack>

      {!isBelowTablet ? (
        <Box className={styles.sliderWrapper}>
          <Swiper
            direction="vertical"
            modules={[Pagination, Mousewheel]}
            mousewheel
            pagination={{
              clickable: true,
              el: `.${styles.customPagination}`,
              bulletClass: styles.bullet,
              bulletActiveClass: styles.bulletActive,
            }}
            slidesPerView={1}
            className={styles.swiper}
          >
            {collaborationProcess.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <SwiperSlide key={index} className={styles.slide} style={{ '--item-color': item.color } as CSSProperties}>
                <CollaborationProcessCard item={item} t={t} tRaw={t.raw} reverse={index % 2 === 1} />
              </SwiperSlide>
            ))}
          </Swiper>
          <Box className={styles.customPagination} />
        </Box>
      ) : (
        <Stack className={styles.mobileCards}>
          {collaborationProcess.map((item, index) => (
            <CollaborationProcessCard
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              item={item}
              t={t}
              tRaw={t.raw}
              style={{ '--item-color': item.color } as CSSProperties}
            />
          ))}
        </Stack>
      )}
    </Container>
  );
};

export default CollaborationProcessSection;
